export default __webpack_public_path__ + "static/gopher-rewards-3eabc7abe444525d740d03d732c0c98a.svg";